import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import { DynamicMuiTheme } from 'Global/Functions/DynamicMuiTheme';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { ThemeContext } from 'Global/Theme/Provider/MuiProvider';
import i18n from 'Lang/i18n';
import React, { useContext } from 'react';

const useCheckUserPrefrences = () => {
  const userColors = localStorage.getItem('userColor');
  const userLanguage = JSON.parse(
    localStorage.getItem('UserLanguage')
  );
  const userFont = localStorage.getItem('UserFont');
  const MoreRows = localStorage.getItem('MoreRows');
  const { setTheme } = useContext(ThemeContext);
  const GlobalConstants = useContext(GlobalContext);

  React.useEffect(() => {
    localStorage.setItem('MoreRows', JSON.stringify(true));
    if (userLanguage) {
      i18n.changeLanguage(userLanguage);
      if (userLanguage === 'en') {
        document.documentElement.style.setProperty(
          '--font-family',
          'Roboto'
        );
      } else {
        if (userLanguage === 'fa') {
          document.documentElement.style.setProperty(
            '--font-family',
            'IranYekan'
          );
        }
        if (userLanguage === 'ar') {
          document.documentElement.style.setProperty(
            '--font-family',
            'IranYekan'
          );
        }
      }
    }

    if (MoreRows) {
      const morerows = JSON.parse(MoreRows);
      GlobalConstants.setMoreColumns(morerows);
    }
    if (userFont) {
      document.documentElement.style.setProperty(
        '--font-family',
        userFont
      );
    }
    if (
      userLanguage &&
      !/^(null|undefined)$/.test(userLanguage)
    ) {
      i18n.changeLanguage(userLanguage);
    }
    if (userColors) {
      const colors = JSON.parse(userColors);

      themeColors.ColorPrimary =
        colors?.primary?.toString();
      themeColors.ColorSecondary =
        colors?.secondary?.toString();
      document.documentElement.style.setProperty(
        '--primary-color',
        colors?.primary?.toString()
      );
      document.documentElement.style.setProperty(
        '--frameColor',
        colors?.secondary?.toString()
      );
      setTheme(
        DynamicMuiTheme(
          colors?.primary?.toString(),
          colors?.secondary?.toString()
        )
      );
      GlobalConstants.setEntirePageRender((prev) => !prev);
    }
  }, [userColors]);
};

export default useCheckUserPrefrences;
